
const typeTab = (() => {
  const pageType = (document.getElementById("pageType") != null);
  if (pageType) {



    const secPlan = document.getElementById('jsSecPlan');
    const bmTabBtn = secPlan.querySelectorAll('.js-bm-tab-box');
    const bmTabCntnt = secPlan.querySelectorAll('.js-bm-cntnt-area');


    let url = new URL(window.location.href);
    let params = url.searchParams;
    let paramsType = params.get('type')
    // console.log(paramsType);
    if (paramsType == 'basic') {

      let bmTabBtnBasic = secPlan.querySelector('.js-bm-tab-box-basic');
      let bmTabCntntBasic = secPlan.querySelector('.js-bm-cntnt-area-basic');
      bmTabBtnBasic.classList.add('act')
      bmTabCntntBasic.classList.add('act')

    } else if (paramsType == 'menu1') {

      let bmTabBtnMenu1 = secPlan.querySelector('.js-bm-tab-box-menu1');
      let bmTabCntntMenu1 = secPlan.querySelector('.js-bm-cntnt-area-menu1');
      bmTabBtnMenu1.classList.add('act')
      bmTabCntntMenu1.classList.add('act')

    } else if (paramsType == 'menu2') {

      let bmTabBtnMenu2 = secPlan.querySelector('.js-bm-tab-box-menu2');
      let bmTabCntntMenu2 = secPlan.querySelector('.js-bm-cntnt-area-menu2');
      bmTabBtnMenu2.classList.add('act')
      bmTabCntntMenu2.classList.add('act')

    } else {
      bmTabBtn[0].classList.add('act')
      bmTabCntnt[0].classList.add('act')
    }



    bmTabBtn.forEach((element, index) => {

      element.addEventListener('click', () => {
        for (let i = 0; i < bmTabBtn.length; i++) {
          bmTabBtn[i].classList.remove('act')
          bmTabCntnt[i].classList.remove('act')
        }
        bmTabBtn[index].classList.add('act')
        bmTabCntnt[index].classList.add('act')
      });

    });


    for (let i = 0; i < bmTabCntnt.length; i++) {

      let diTabBtn = bmTabCntnt[i].querySelectorAll('.js-di-tab');
      let diTabCntnt = bmTabCntnt[i].querySelectorAll('.js-di-cntnt-box');

      // if (diTabBtn.length > 1) {
      //   diTabBtn[1].classList.add('act')
      //   diTabCntnt[1].classList.add('act')
      // } else {
      //   diTabBtn[0].classList.add('act')
      //   diTabCntnt[0].classList.add('act')
      // }
      diTabBtn[0].classList.add('act')
      diTabCntnt[0].classList.add('act')

      diTabBtn.forEach((element, index) => {

        element.addEventListener('click', () => {
          for (let i = 0; i < diTabBtn.length; i++) {
            diTabBtn[i].classList.remove('act')
            diTabCntnt[i].classList.remove('act')
          }
          diTabBtn[index].classList.add('act')
          diTabCntnt[index].classList.add('act')
        });

      });

    }



  }
})();
export default typeTab;